import { useState, useEffect } from 'react';
import Navbar from '../guide/components/Navbar';
import PrivacyContent from './components/PrivacyContent';
import Footer from '../home/components/Footer';

export default function PrivacyPage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar scrolled={scrolled} />
      <PrivacyContent />
      <Footer />
    </div>
  );
}
